module.exports = __webpack_public_path__ + "static/media/next-question.1da55d31.svg";